import { initializeCustomValvePlacement } from "./form/customValvePlacement";
import { initializeForm } from "./form/formSubmission";
import { initializeGallery } from "./gallery";

/** Initializes the product page. */
export function productPage(): void {
	initializeCustomValvePlacement();
	initializeForm();
	initializeGallery(".rt-pspr-thumbnail", "rt-pspr-featured-image");
}
